import { Component, OnDestroy } from '@angular/core';
import { AppState } from './core/app.states';
import { Store } from '@ngrx/store';
import { ClearStore } from 'auth';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy {
  title = 'apmailing-lmsrouter-ui';

  constructor(private store: Store<AppState>) {}

  ngOnDestroy() {
    this.store.dispatch(new ClearStore());
  }
}
